import {
  Button,
  Classes,
  Dialog,
  FormGroup,
  H4,
  InputGroup,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { createViewModel, IViewModel } from "mobx-utils";
import * as React from "react";
import { ICalcVar } from "../../model";
import { CalcVarFcpLegend } from "./CalcVarFcpLegend";
import { NotaVarFcpStore } from "../../stores/vars/NotaVarFcpStore";
import { toast } from "react-toastify";

interface CalcVarFcpDialogProps {
  allVarsFcp: ICalcVar[];
  calcVar: ICalcVar;
  onClose: () => void;
  onConfirm: () => void;
}

interface CalcVarFcpDialogState {
}

@observer
export class CalcVarFcpDialog
  extends React.Component<CalcVarFcpDialogProps, CalcVarFcpDialogState> {
  obs = observable({
    calcVar: {} as IViewModel<ICalcVar> & ICalcVar
  })

  componentDidMount() {
    this.obs.calcVar = createViewModel(this.props.calcVar);
  }

  validarExpressao(nomesValidos: any, expressao: string): { valido: boolean, erro?: string } {

    try {

      let expressaoSubstituida = expressao;

      for (const nome of nomesValidos) {

        const regex = new RegExp(`\\b${nome}\\b`, 'g');

        expressaoSubstituida = expressaoSubstituida.replace(regex, '1');

      }

      const regexTokens = /[a-zA-Z_][a-zA-Z0-9_]*/g;

      const tokensRestantes = expressaoSubstituida.match(regexTokens);

      if (tokensRestantes && tokensRestantes.length > 0) {

        return { valido: false, erro: `Variáveis inválidas: ${tokensRestantes.join(', ')}` };

      }

      new Function(`return ${expressaoSubstituida}`)();

      return { valido: true };

    } catch (err) {

      return { valido: false, erro: "Expressão inválida." };

    }

  }

  handleOk = () => {

    const nomesValidos = [...NotaVarFcpStore.obs.vars_fcp, ...this.props.allVarsFcp].map(p => p.nome);

    const resultado = this.validarExpressao(nomesValidos, this.obs.calcVar.expr);

    if (resultado.valido) {

      this.props.onConfirm();
      this.obs.calcVar.submit();
      this.props.onClose();

    } else {

      toast.error(`${resultado.erro}`)

    }

  };

  handleCancel = () => {
    this.props.onClose();
  };

  render() {
    return (
      <Dialog
        isOpen
        title={this.obs.calcVar.nome || "Sem nome"}
        onClose={this.handleCancel}
        style={{ width: 800 }}
      >
        <div className={Classes.DIALOG_BODY} style={{ display: "flex" }}>
          <div style={{ width: 480, marginRight: 20 }}>
            <FormGroup
              label="Nome"
              labelFor="nome"
              labelInfo="(obrigatório)"
              helperText="Nome da variável"
            >
              <InputGroup
                id="nome"
                value={this.obs.calcVar.nome}
                onChange={(e: any) => this.obs.calcVar.nome = e.target.value}
              />
            </FormGroup>

            <FormGroup
              label="Descrição"
              labelFor="descricao"
              helperText="Descrição da variável"
            >
              <InputGroup
                id="descricao"
                value={this.obs.calcVar.descricao}
                onChange={(e: any) => this.obs.calcVar.descricao = e.target.value}
              />
            </FormGroup>

            <FormGroup
              label="Expressão"
              labelFor="expr"
              labelInfo="(obrigatório)"
              helperText="Expressão"
            >
              <InputGroup
                id="expr"
                value={this.obs.calcVar.expr}
                className="nz-expr-editor"
                onChange={(e: any) => this.obs.calcVar.expr = e.target.value}
                leftIcon="variable"
              />
            </FormGroup>
          </div>
          <div>
            <H4>Variáveis disponíveis</H4>
            <CalcVarFcpLegend
              varsFcp={this.props.allVarsFcp.slice(0, this.obs.calcVar.order - 1)}
            />
          </div>
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Ok" intent="primary" onClick={this.handleOk} />
            <Button text="Cancelar" onClick={this.handleCancel} />
          </div>
        </div>
      </Dialog>
    );
  }
}
